<div class="very_small_dialog flex_column unselectable" role="dialog" tabindex="0" autofocus>
	<div class="div_innerHTML h4 fw400 flex_column margin_bottom_large" [innerHTML]="innerHTML | safeHtml" [ngClass]="{'align_items_center text_align_center': center}"></div>

	<div mat-dialog-actions [align]="'center'" class="flex gap_small">
		<button mat-button [mat-dialog-close]="false" class="button_medium fw600">{{ negativeButtonCaption }}</button>
		<button mat-flat-button [color]="positiveButtonColor" [mat-dialog-close]="true" class="button_medium fw600">{{ positiveButtonCaption }}</button>
	</div>
</div>